/*
 * File: /src/services/aiAgentService.js
 * Author: AdBase, Inc.
 * Copyright (c) 2024 AdBase, Inc.
 */

import { authedAxios } from '../shared/axiosWrapper';
import { S2_AI_AGENTS_PATH } from '../constants';

export default {
  fetchAll() {
    return authedAxios.get(S2_AI_AGENTS_PATH);
  },
  fetchById(id) {
    return authedAxios.get(S2_AI_AGENTS_PATH + id);
  },
  updateAiAgent(id, payload) {
    return authedAxios.put(S2_AI_AGENTS_PATH + id, payload);
  },
  createAiAgent(payload) {
    return authedAxios.post(S2_AI_AGENTS_PATH, payload);
  },
  deleteAiAgent(id) {
    return authedAxios.delete(S2_AI_AGENTS_PATH + id);
  },
};
